import { render, staticRenderFns } from "./viewSUMUL.vue?vue&type=template&id=063d4025&scoped=true"
import script from "./viewSUMUL.vue?vue&type=script&lang=js"
export * from "./viewSUMUL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d4025",
  null
  
)

export default component.exports